<div
    class="cmps-event-centre-c-pop-text--standard cmps-cdk-d-block cmps-cdk-bg-color-grey-200 cmps-cdk-color-black cmps-cdk-font-bold cmps-cdk-p-1 cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-justify-content-center cmps-cdk-align-items-center"
>
    <span>{{ _data?.value }}</span>
</div>
